import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../styles/GalleryPromo.module.css';

const publicUrl = process.env.PUBLIC_URL || '';

function GalleryPromo() {
  return (
    <section className={styles.section} aria-labelledby="gallery-promo-title">
      <Link className={styles.card} to={`${publicUrl}/Galerie`}>
        <span className={styles.overlay} aria-hidden="true" />
        <span className={styles.content}>
          <span className={styles.eyebrow}>Grain Bites</span>
          <span className={styles.title} id="gallery-promo-title">Galerie</span>
          <span className={styles.cta}>Explore the gallery</span>
        </span>
      </Link>
    </section>
  );
}

export default GalleryPromo;
